import type { ReadonlyRecord } from '../../../utils'

import type { UserManagementTabsTypes } from '../../../domain'

import { AbsoluteRouteOnlyPath } from '../routing'

export const tabs: ReadonlyRecord<keyof UserManagementTabsTypes, AbsoluteRouteOnlyPath> = {
    users: AbsoluteRouteOnlyPath.USER_MANAGEMENT_USERS,
    roles: AbsoluteRouteOnlyPath.USER_MANAGEMENT_ROLES,
    permissions: AbsoluteRouteOnlyPath.USER_MANAGEMENT_PERMISSIONS,
}
